module.exports = __webpack_public_path__ + "img/small-plants.316543a3.svg";